import './welcome.scss';
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { PAYMENT_METHOD, PRODUCTION, SOCIAL_URL } from '../../config/config';
import { AlertSuccess } from '../../components/Alert';
import Button from '../../components/Button';
import { useEffect } from 'react';
import { onlyIscriptionCourses, onlyIscriptionPostGrado, onlyIscriptions } from '../../utils/app_manage';
export default function Welcome({ setStep, token, payment_method, invoiceData, setstep1Data, setPaymentMethod, setInvoiceData }) {
    //console.log({ invoiceData });
    const { facebook, instagram, tiktok, whatsapp, linkedin, youtube, x } = SOCIAL_URL;
    const goHome = () => {
        setStep(0);
        setstep1Data({
            document_type: '',
            document_number: '',
            name: '',
            surname: '',
            email: '',
            whatsapp_prefix: '',
            whatsapp_number: ''
        });
        setPaymentMethod(PAYMENT_METHOD.online.id);
        setInvoiceData();
    }

    useEffect(() => {
        return () => clearInterval();
    })

    return (
        <motion.div
            initial={{ x: x }}
            transition={{ duration: 0.5 }}
            animate={{ x: 0 }}
        >
            <div className='welcome_row'>
                <div className='left'>
                    <h1>¡Te damos la bienvenida!</h1>
                    <h4>Seguinos en nuestras redes</h4>
                    <div className='social-icons'>
                        <a href={facebook} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaFacebookF />
                        </a>
                        <a href={instagram} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaInstagram />
                        </a>
                        <a href={tiktok} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaTiktok />
                        </a>
                        <a href={whatsapp} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaWhatsapp />
                        </a>
                        <a href={linkedin} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaLinkedinIn />
                        </a>
                        <a href={youtube} target='_blank' rel="noopener noreferrer" className="icon">
                            <FaYoutube />
                        </a>
                    </div>
                </div>
                <div className='right'>
                    <div className='box box-flex alert-box'>
                        <div className="box-header">
                        </div>
                        {payment_method === PAYMENT_METHOD.online.id &&
                            <>
                                <div className="box-body">
                                    <div className="body">
                                        <h2 className='mb-2'>¡Pre-inscripción Finalizada!</h2>
                                        <AlertSuccess>Para completar la inscripción de tu {onlyIscriptionCourses()? 'capacitación': 'carrera'} deberás abonar la matrícula vía online o descargando la boleta de pago.</AlertSuccess>
                                    </div>
                                </div>
                                <div className='box-footer btn-group'>
                                    {PRODUCTION ? 
                                       <a href={`https://www.ucasal.edu.ar/boleta/index.php?nroTran=${invoiceData.nrotransac}&appOrigen=LANDING_GENERAL&hashTransaccion=${invoiceData.hashTransaccion}`} target='_blank' rel="noopener noreferrer" className="btn btn-step btn-link">Pago Online</a>                                      
                                    :
                                        <a href={`https://www-desa.ucasal.edu.ar/ucs-pagos/#/proveedor-pagos?nroTran=${invoiceData.nrotransac}&appOrigen=LANDING_GENERAL&hashTransaccion=${invoiceData.hashTransaccion}`} target='_blank' rel="noopener noreferrer" className="btn btn-step btn-link">Pago Online</a>
                                    }
                                    <a href={`https://www.ucasal.edu.ar/boleta/index.php?sucursal=${invoiceData.nrocomp1}&recibo=${invoiceData.nrocomp2}&appOrigen=LANDING_GENERAL`} target='_blank' rel="noopener noreferrer" className="btn btn-step btn-link">Boleta de pago</a>
                                </div>
                            </>
                        }
                        {
                            payment_method === PAYMENT_METHOD.email.id && 
                            <>
                                <div className="box-body">
                                    <div className='body'>
                                        {   onlyIscriptionPostGrado() &&
                                            <h2 className='my-2'>¡Pre inscripción finalizada!</h2>
                                        }
                                        {   onlyIscriptionCourses() &&
                                            <h2 className='my-2'>¡Pre inscripción finalizada!</h2>
                                        }
                                        {   onlyIscriptions() &&
                                            <h2 className='my-2'>¡Pre-inscripción Finalizada!</h2>
                                        }
                                        <AlertSuccess>Completá tu inscripción abonando el cupón de tu matrícula, que enviamos al correo</AlertSuccess>
                                    </div>
                                </div>
                                <div className='box-footer btn-group'>
                                    <Button type="button" className='btn-step btn-goback' onClick={goHome}>Inicio</Button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </motion.div >
    )
}